import {FC} from 'react'

type Props = {
  customerName?: string
}

const CustomerName: FC<Props> = ({customerName}) => (
  <span className='fs-7 text-uppercase'>{customerName || '-'}</span>
)

export {CustomerName}